import React from 'react';
import { Page } from '../Page';
const tocSections = [{
  part: 'Part One: Understanding Your Medication',
  items: [{
    title: 'What Is GLP-1 Medication?',
    page: 2
  }, {
    title: 'GLP-1 And The Gut',
    page: 3
  }, {
    title: 'GLP-1 And The Brain',
    page: 4
  }, {
    title: 'Managing Your Dose',
    page: 5
  }]
}, {
  part: 'Part Two: The Fundamentals',
  items: [{
    title: 'The Fundamentals',
    page: 6
  }, {
    title: 'Calories, Carbohydrates, and Fat',
    page: 7
  }, {
    title: 'Numbers Are a Starting Point',
    page: 8
  }]
}, {
  part: 'Part Three: The Essentials',
  items: [{
    title: 'Protein',
    page: 9
  }, {
    title: 'Choosing Lean Proteins',
    page: 10
  }, {
    title: 'Vitamins & Minerals',
    page: 11
  }, {
    title: 'Fiber',
    page: 12
  }, {
    title: 'Hydration',
    page: 13
  }, {
    title: 'When and How Often to Eat',
    page: 14
  }, {
    title: 'How to Plate a Meal',
    page: 15
  }, {
    title: 'The Fist Method',
    page: 16
  }, {
    title: 'Weight Lifting',
    page: 17
  }, {
    title: 'Cardio',
    page: 18
  }, {
    title: 'Sleep',
    page: 19
  }, {
    title: 'When Calories Start to Matter',
    page: 20
  }]
}];
const tocSections2 = [{
  part: 'Part Four: Supplements',
  items: [{
    title: 'Why Supplement Quality Matters',
    page: 21
  }, {
    title: 'Whey Protein',
    page: 22
  }, {
    title: 'Multivitamin',
    page: 23
  }, {
    title: 'Vitamin D',
    page: 24
  }, {
    title: 'CoQ10',
    page: 25
  }, {
    title: 'Omega-3',
    page: 26
  }, {
    title: 'Electrolytes',
    page: 27
  }, {
    title: 'Creatine',
    page: 28
  }, {
    title: 'Ashwagandha (Muscle)',
    page: 29
  }, {
    title: 'Sleep Support',
    page: 30
  }, {
    title: 'Magnesium',
    page: 31
  }, {
    title: 'Ashwagandha',
    page: 32
  }, {
    title: 'Glutathione',
    page: 33
  }]
}, {
  part: 'Part Five: Side Effects & Challenges',
  items: [{
    title: 'Acute Side Effects',
    page: 34
  }, {
    title: 'Chronic Side Effects',
    page: 35
  }, {
    title: 'Alcohol',
    page: 36
  }, {
    title: 'Plateaus',
    page: 37
  }]
}, {
  part: 'Part Six: Looking Ahead',
  items: [{
    title: 'Transitioning Off Medication',
    page: 38
  }]
}];
export function PageTOC() {
  return <Page hideFooter variant="light" data-id="element-1469">
      <div className="flex flex-col h-full pt-12" data-id="element-1470">
        <div className="mb-10" data-id="element-1471">
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight" data-id="element-1472">
            Table of
            <br data-id="element-1473" />
            Contents
          </h1>
          <div className="w-16 h-0.5 bg-tealslate mt-5" data-id="element-1474" />
        </div>

        <div className="grid grid-cols-2 gap-x-12 gap-y-8 flex-1" data-id="element-1475">
          {/* Left column */}
          <div className="space-y-6" data-id="element-1476">
            {tocSections.map((section, sIdx) => <div key={sIdx} data-id="element-1477">
                <div className="text-[10px] font-bold text-tealslate uppercase tracking-[0.15em] mb-2" data-id="element-1478">
                  {section.part}
                </div>
                <div className="space-y-0" data-id="element-1479">
                  {section.items.map((item, iIdx) => <div key={iIdx} className="flex items-baseline gap-2 py-1 border-b border-[#D8D8D0] last:border-b-0" data-id="element-1480">
                      <span className="text-[#3B3B3B] text-xs" data-id="element-1481">
                        {item.title}
                      </span>
                      <span className="flex-1 border-b border-dotted border-[#D8D8D0] mb-0.5" data-id="element-1482" />
                      <span className="text-tealslate font-bold text-xs tabular-nums" data-id="element-1483">
                        {item.page}
                      </span>
                    </div>)}
                </div>
              </div>)}
          </div>

          {/* Right column */}
          <div className="space-y-6" data-id="element-1484">
            {tocSections2.map((section, sIdx) => <div key={sIdx} data-id="element-1485">
                <div className="text-[10px] font-bold text-tealslate uppercase tracking-[0.15em] mb-2" data-id="element-1486">
                  {section.part}
                </div>
                <div className="space-y-0" data-id="element-1487">
                  {section.items.map((item, iIdx) => <div key={iIdx} className="flex items-baseline gap-2 py-1 border-b border-[#D8D8D0] last:border-b-0" data-id="element-1488">
                      <span className="text-[#3B3B3B] text-xs" data-id="element-1489">
                        {item.title}
                      </span>
                      <span className="flex-1 border-b border-dotted border-[#D8D8D0] mb-0.5" data-id="element-1490" />
                      <span className="text-tealslate font-bold text-xs tabular-nums" data-id="element-1491">
                        {item.page}
                      </span>
                    </div>)}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </Page>;
}